import useLayeredContent from './useLayeredContent'
import type { GamePage } from '../../utils/game-pages-config'

export function useContentGamePage() {
    const { queryAll, queryBySlug } = useLayeredContent()

    async function getGamePages() {
        const all = await queryAll<GamePage>('game-pages')
        return all
            .filter(p => p.seoName !== 'overview' && p.seoName)
            .sort((a, b) => (a.seoName || '').localeCompare(b.seoName || ''))
    }

    async function getGamePageBySeoName(seoName: string) {
        return await queryBySlug<GamePage>('game-pages', seoName)
    }

    async function getGamePageOverview() {
        return await queryBySlug<GamePage>('game-pages', 'overview')
    }

    return { getGamePages, getGamePageBySeoName, getGamePageOverview }
}
